declare global {
  interface Window {
    env?: Record<string, string>;
  }
}

export function getEnv(key: string): string {
  return window.env?.[key] || (import.meta.env[key] as string) || '';
}
